import uiModal from './default/index.vue'
import uiModalMessage from './message/index.vue'
import uiModalMessageV2 from './message-v2/index.vue'
import uiModalSteps from './steps/index.vue'
import uiStep from './steps/step.vue'
import uiModalInfo from './info/index.vue'
import uiModalCancelButton from './util/cancel-button/index.vue'
import uiModalActionsArea from './util/actions-area/index.vue'

export {
	uiModal,
	uiModalMessage,
	uiModalMessageV2,
	uiModalSteps,
	uiModalInfo,
	uiModalCancelButton,
	uiModalActionsArea,
	uiStep,
}
